import { ChakraGridItem, ChakraSimpleGrid } from '@equip.health/ui';

import { hasPrimaryDiagnosis } from '~/lib/util/clinicalProfile.util';

import DiagnosisListItem from './DiagnosisListItem';

interface DiagnosisListProps {
  diagnosisIdToEdit: string;
  diagnosisList: PatientDiagnosis[];
  onAdd: () => void;
  patientId?: string;
  validatedDiagnosisHasCodeAlready: (
    diagnosisCode: string,
    updatedStatusCode: string,
    skipDiagnosisId?: string,
  ) => boolean;
  setDiagnosisIdToEdit: (diagnosesIdToEdit: string) => void;
}

const DiagnosisList = ({
  diagnosisIdToEdit,
  diagnosisList,
  onAdd,
  patientId,
  validatedDiagnosisHasCodeAlready,
  setDiagnosisIdToEdit,
}: DiagnosisListProps) => (
  <ChakraSimpleGrid marginY="10px">
    {(diagnosisList ?? []).map((diagnosis, index) => (
      <ChakraGridItem key={`${diagnosis.externalId + index}`}>
        <DiagnosisListItem
          diagnosis={diagnosis}
          diagnosisIdToEdit={diagnosisIdToEdit}
          isPrimaryDiagnosisExists={hasPrimaryDiagnosis(
            diagnosisList,
            diagnosis,
          )}
          onAdd={onAdd}
          patientId={patientId}
          setDiagnosisIdToEdit={setDiagnosisIdToEdit}
          validatedDiagnosisHasCodeAlready={validatedDiagnosisHasCodeAlready}
        />
      </ChakraGridItem>
    ))}
  </ChakraSimpleGrid>
);
export default DiagnosisList;
